(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["starry-cart-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('starry-cart-button')) {
    customElements.define(
      'starry-cart-button',
      /**
       * Starry 场景加购按钮：读取变体与数量，通过购物车永久链接跳转 `/cart/{variantId}:{quantity}` 加购。
       * 点击委托在宿主上（捕获阶段），避免同页多实例、且避免外层 `<a>` 包裹卡片时非法嵌套 `<button>` 导致只有首张卡片可点。
       * 处理点击后 `stopPropagation`，防止冒泡到父级 `<a>` 打开商品页。
       */
      class StarryCartButton extends HTMLElement {
        constructor() {
          super();
          this._onHostClick = this._handleHostClick.bind(this);
        }

        connectedCallback() {
          this._init();
        }

        disconnectedCallback() {
          this._cleanup();
        }

        _init() {
          if (this._hostDelegated) return;
          if (!this.querySelector('input[name="id"]')) return;

          /* 委托在宿主上，点击路径含 SVG/文案时也能命中；捕获阶段早于外层 `<a>` 的默认跳转 */
          this.addEventListener('click', this._onHostClick, true);
          this._hostDelegated = true;
        }

        _cleanup() {
          if (!this._hostDelegated) return;
          this.removeEventListener('click', this._onHostClick, true);
          this._hostDelegated = false;
        }

        _handleHostClick(e) {
          const btn = e.target.closest('.custom-add-to-cart');
          if (!btn || !this.contains(btn)) return;

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          if (btn.disabled) return;

          const input = this.querySelector('input[name="id"]');
          const variantId = input ? input.value : '';

          const selector = this.getAttribute('data-quantity-selector');
          const quantityInput = selector ? document.querySelector(selector) : null;
          let quantity = 1;

          if (quantityInput && quantityInput.value) {
            const q = parseInt(quantityInput.value, 10);
            quantity = isNaN(q) || q <= 0 ? 1 : q;
          } else {
            const quantityAttr = this.getAttribute('data-quantity');
            quantity = Math.max(1, parseInt(quantityAttr || '1', 10) || 1);
          }

          if (!variantId) {
            console.error('[starry-cart-button] Missing variant id');
            return;
          }

          window.location.href = '/cart/' + variantId + ':' + quantity;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
